import { Stack } from "@mui/material"
import { ReactElement, useContext } from "react"
import { useForm } from "react-hook-form"

import { useFilterReferenceMappings } from "../../../../../hooks/useFilterReferenceMappings"
import { GRID_SPACING } from "../../../../../themes/defaultThemeParams"
import FormErrors from "../../../../formErrors/formErrors"
import FormHeader from "../../../../formHeader/formHeader"
import FormNavigation from "../../../../formNavigation/formNavigation"
import ValidatedAutocomplete from "../../../../inputs/validated/validatedSelect"
import { AppCard } from "../../../../surfaces/appCard"
import { MANU_SUBTITLE } from "../../../common/labels"
import { CreateV2GBundleContext } from "../providers/baseProviders/createV2GBundleProvider"

const MANUFACTURER_REG = "bundleManufacturer"

const BundleManufacturer = (): ReactElement => {
    const {
        currentIndex,
        setCurrentIndex,
        evacFormData,
        setEvacFormData,
        setTtrFormData,
    } = useContext(CreateV2GBundleContext)

    const { manufacturerMappings, manufacturerIds, isLoading } =
        useFilterReferenceMappings()

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            [MANUFACTURER_REG]: evacFormData.manufacturerId,
        },
        values: {
            [MANUFACTURER_REG]: evacFormData.manufacturerId,
        },
        shouldUnregister: true,
    })

    const onClickNext = (): void => {
        const manufacturerId = watch(MANUFACTURER_REG) as string
        setEvacFormData((prev) => ({ ...prev, manufacturerId }))
        setTtrFormData((prev) => ({
            ...prev,
            coreDetails: {
                ...prev.coreDetails,
                manufacturer: Number(manufacturerId),
            },
        }))
        setCurrentIndex(currentIndex + 1)
    }

    return (
        <AppCard>
            <Stack spacing={GRID_SPACING * 2}>
                <FormHeader
                    header="Manufacturer"
                    subHeader={MANU_SUBTITLE}
                    index={currentIndex + 1}
                />
                <ValidatedAutocomplete
                    control={control as never}
                    required
                    registerName={MANUFACTURER_REG}
                    label="Manufacturer"
                    options={manufacturerIds}
                    getOptionLabel={(option: number) =>
                        manufacturerMappings[option]
                    }
                    loading={isLoading}
                />
                <FormErrors
                    errors={errors as never}
                    getFriendlyName={() => "Manufacturer"}
                />
                <FormNavigation
                    onClickNext={() => handleSubmit(onClickNext)()}
                    nextText="Next"
                    nextDisabled={isLoading}
                />
            </Stack>
        </AppCard>
    )
}

export default BundleManufacturer
